var map = {
	"./buyOneGetOneFree.json": 780,
	"./cashVoucherWithPurchase.json": 781,
	"./discountedProductWithPurchase.json": 782,
	"./freeGift.json": 783,
	"./giftWithPurchase.json": 784,
	"./priceDiscount.json": 785,
	"./priceReduction.json": 786,
	"./prizeDrawWithPurchase.json": 787,
	"./productIntroduction.json": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 779;